/* eslint-disable no-param-reassign */
import Notifications from './Notifications.vue'

export const NotificationStore = {
  state: [], // here the notifications will be added
  settings: {
    overlap: false,
    verticalAlign: 'top',
    horizontalAlign: 'right',
    type: 'info',
    timeout: 8000,
    closeOnClick: true,
    showClose: true,
    order: 'reverse' // normal | reverse (When reverse, each notification will be added on top)
  },
  setOptions(options) {
    this.settings = Object.assign(this.settings, options)
  },
  removeNotification(timestamp) {
    const indexToDelete = this.state.findIndex(n => n.timestamp === timestamp)
    if (indexToDelete !== -1) {
      this.state.splice(indexToDelete, 1)
    }
  },
  addNotification(notification) {
    // timeout
    if (notification.type === 'danger') this.settings.timeout = 20000
    else if (notification.type === 'warning') this.settings.timeout = 15000
    else if (notification.type === 'info') this.settings.timeout = 3000

    if (typeof notification === 'string' || notification instanceof String) {
      notification = { message: notification }
    }
    notification.timestamp = new Date()
    notification.timestamp.setMilliseconds(notification.timestamp.getMilliseconds() + this.state.length)
    notification = Object.assign({}, this.settings, notification)
    if (this.settings.order === 'reverse') {
      this.state.unshift(notification)
    } else {
      this.state.push(notification)
    }
  },
  notify(notification) {
    if (Array.isArray(notification)) {
      notification.forEach(notificationInstance => {
        this.addNotification(notificationInstance)
      })
    } else {
      this.addNotification(notification)
    }
  }
}

const NotificationsPlugin = {
  install(Vue, options) {
    // eslint-disable-next-line prefer-const
    let app = new Vue({
      data: {
        notificationStore: NotificationStore
      },
      methods: {
        notify(notification) {
          this.notificationStore.notify(notification)
        }
      }
    })
    Vue.prototype.$notify = app.notify
    Vue.prototype.$notifications = app.notificationStore
    Vue.component('Notifications', Notifications)
    if (options) {
      NotificationStore.setOptions(options)
    }
  },
  extNotify(notification) {
    this.notificationStore.notify(notification)
  }
}

export default NotificationsPlugin
